import { getAuthToken, handleApiError } from './apiUtils';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000/api/v1';

export interface ConsignmentPricingItem {
    id: number;
    consignment_no: string;
    created_at: string;
    cod_amount: number;
    status: {
        id: number;
        name: string;
        badge?: string;
    };
    pricing: {
        status_id: number;
        cod_amount: number;
        service_charges: number;
        tax: number;
        weight: number;
        fee: number;
        multiple: number;
        extra: number;
        status?: {
            id: number;
            name: string;
        };
    };
}

export interface PricingData {
    consignments: ConsignmentPricingItem[];
    consignmentsCount: number;
    selectedUser?: {
        id: number;
        name: string;
    };
    FromDate?: string;
    ToDate?: string;
    isDateCheck?: number;
}

export interface PricingParams {
    customer_id?: number;
    FromDate?: string;
    ToDate?: string;
    print?: number;
}

export interface BackendResponse<T> {
    success: boolean;
    message: string;
    data: T;
}

export const consignmentPricingApi = {
    // Get pricing data with filters
    getPricingData: async (params?: PricingParams): Promise<PricingData> => {
        const token = getAuthToken();
        if (!token) throw new Error('No authentication token');

        const queryParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                queryParams.append(key, value.toString());
            }
        });

        const response = await fetch(`${API_BASE_URL}/consignments/pricing?${queryParams}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            await handleApiError(response);
        }

        const data: BackendResponse<PricingData> = await response.json();
        return data.data;
    },

    // Download PDF
    downloadPdf: async (params?: PricingParams): Promise<Blob> => {
        const token = getAuthToken();
        if (!token) throw new Error('No authentication token');

        const queryParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                queryParams.append(key, value.toString());
            }
        });
        // Force print parameter
        queryParams.append('print', '1');

        const response = await fetch(`${API_BASE_URL}/consignments/pricing?${queryParams}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            await handleApiError(response);
        }

        return await response.blob();
    },
};
